<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de procedimentos lançados por período">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/ambulatorio/relatorio-procedimento-lancado-periodo/List'

export default {
    components: { List },
}
</script>